import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../Language";

export const errorStatus = {
  unauthorized: 401,
  forbidden: 403,
  notFound: 404,
};

const statusMessage = {
  401: "Unauthorized",
  403: "Forbidden",
  404: "Diese Seite konnte nicht gefunden werden.",
};

const ErrorPage = (props) => {
  const { t } = useLanguage();
  return (
    <div
      style={{
        padding: "15vh 0 15vh 0",
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h1
        style={{
          fontWeight: "bold",
          fontSize: "min(10vmin, 100px)",
          color: "var(--primaryContrastColor)",
        }}
      >
        {props.status}
      </h1>
      <h2 style={{ color: "var(--primaryContrastColor)" }}>
        {t(statusMessage[props.status])}
      </h2>
      <Link className="action action-primary" style={{ marginTop: 30 }} to="/">
        {t("Zur Startseite")}
      </Link>
    </div>
  );
};

export default ErrorPage;
